import { render, staticRenderFns } from "./customersalesorder.vue?vue&type=template&id=21d4eaa4&scoped=true"
import script from "./customersalesorder.vue?vue&type=script&lang=js"
export * from "./customersalesorder.vue?vue&type=script&lang=js"
import style0 from "./customersalesorder.vue?vue&type=style&index=0&id=21d4eaa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4eaa4",
  null
  
)

export default component.exports